// Türkçe sözlük — temel (base) dil. Yeni metin eklerken önce buraya ekle,
// sonra en.ts'e karşılığını yaz (tip, aynı yapıyı zorunlu kılar).
export const tr = {
  signInMethods: {
    // D-871 — the linked Google accounts, and removing one.
    googleAccountUnknown: "Google hesabı (adresi henüz bilinmiyor)",
    googleLinkedDate: "Bağlandı: {date}",
    googleRemove: "Kaldır",
    googleRemoveTitle: "Bu Google hesabı kaldırılsın mı?",
    googleRemoveBody: "Önce kayıtlı numaranı doğrulayacaksın. Sonra bu Google hesabıyla nosubject’e giriş yapılamaz.",
    googleRemoveConfirm: "{account} hesabını kaldırmak için kodu gir.",
    googleRemoved: "Google hesabı kaldırıldı.",
    googleLastMethod: "Bu, hesabına girmenin tek yolu; kaldırılamaz.",
    googleAddAnother: "Başka bir Google hesabı bağla",
    googleLinkedCount: "Bağlı Google hesabı sayısı: {count}",
    googleLinked: "Google hesabı bağlı.",
    googleCodeSent: "{phone} ile biten kayıtlı numarana kod gönderildi.",
    googleChooseHint: "Seçeceğin Google hesabı, bu nosubject hesabına giriş yapmak için bağlanacak.",
    googleStatusUnknown: "Google bağlantı durumu kontrol edilemedi. Tekrar kontrol et.",
    googleLinkIntro: "Google hesabını bağlamak için önce bu hesabın kayıtlı telefonunu doğrula.",
    googleLinkFailed: "İşlem tamamlanamadı. Tekrar dene.",
    googleSendCode: "Doğrulama kodu gönder",
    googleCodeLabel: "Doğrulama kodu",
    googleStartAgain: "Baştan başla",
    googleContinue: "Google ile devam et",
    googleFailed: "Google ile giriş tamamlanamadı. Tekrar dene.",
    googleNotLinked: "Bu Google hesabı henüz bir nosubject hesabına bağlı değil.",
    googleUnavailable: "Google ile giriş henüz kullanıma açık değil.",
    title: "Giriş yöntemleri",
    intro: "Bu bölüm hazırlanıyor. Giriş yöntemlerini yönetme seçenekleri daha sonra eklenecek.",
    identity: "Kimlik doğrulama",
    identityInfo: "Kimliğin doğrulanması, hesaba girişten ayrı bir işlemdir.",
  },
  safety: {
    title: 'Güvenlik numarası',
    compare: '{name} ile bu numarayı karşılaştır. Aynıysa, aranıza giren biri mesajlarınızı okuyamaz.',
    explainInfo: 'Numara, ikinizin şu anki bütün cihazlarının şifreleme anahtarlarından hesaplanır ve iki telefonda da aynı görünür. Biriniz yeni bir telefon ya da web gibi yeni bir cihaz eklerse numara değişir; o zaman yeniden karşılaştırın. Doğrulama yalnız bu cihazda saklanır.',
    qrLabel: 'Güvenlik numarasının QR kodu',
    verified: 'Doğrulandı',
    notVerified: 'Doğrulanmadı',
    markVerified: 'Doğruladım',
    clearVerified: 'Doğrulamayı kaldır',
    peerUnavailable: 'Bu kişiyle şifreleme henüz açık değil.',
    selfUnavailable: 'Bu cihazın şifreleme anahtarı henüz hazır değil.',
    loadFailed: 'Güvenlik numarası yüklenemedi',
  },
  backup: {
    title: 'Sohbet yedeği',
    explainInfo: 'Geçmişin cihazında duruyor. Yedek, onu kurtarma kodunla şifreleyip sunucuda saklar; biz açamayız.',
    create: 'Yedek oluştur',
    refresh: 'Yedeği güncelle',
    codeTitle: 'Kurtarma kodun',
    codeWarning: 'Bu kodu güvenli bir yere kaydet. Kaybedersen geçmişin geri gelmez, biz de açamayız.',
    restoreTitle: 'Geçmişi geri yükle',
    restorePlaceholder: 'Kurtarma kodu',
    restore: 'Geri yükle',
    restored: '{count} mesaj geri yüklendi.',
    restoreFailed: 'Geçmiş açılamadı. Kodu kontrol et.',
    failed: 'Yedek alınamadı',
  },
  common: {
    clear: "Aramayı temizle",
    infoHide: 'Açıklamayı gizle: {subject}',
    infoShow: 'Açıklamayı göster: {subject}',
    continue: 'Devam et',
    cancel: 'İptal',
    close: 'Kapat',
    save: 'Kaydet',
    done: 'Tamam',
    retry: 'Tekrar dene',
    error: 'Hata',
    back: 'Geri',
    search: 'Ara…',
    loading: 'Yükleniyor',
    remove: 'Kaldır',
    offline: 'Sunucuya ulaşılamıyor. Bağlantını kontrol et.',
    sessionExpired: 'Oturumun sona erdi. Yeniden giriş yap.',
    tooManyRequests: 'Çok fazla istek gönderildi. Biraz bekleyip tekrar dene.',
  },
  time: {
    now: 'şimdi',
    minAgo: '{n} dk önce',
    hourAgo: '{n} sa önce',
    yesterday: 'dün',
    dayAgo: '{n} gün önce',
    weekAgo: '{n} hafta önce',
    weekAgoOne: '{n} hafta önce',
    today: 'Bugün',
    dayYesterday: 'Dün',
  },
  phone: {
    sendFailed: "Kod gönderilemedi. Tekrar dene.",
    subtitle: 'Telefon numaranı gir',
    selectCountry: 'Ülke / bölge',
    countrySearch: 'Ülke ara…',
    architectureLink: 'Teknik mimari ve yol haritası ↗',

  },
  otp: {
    verifyFailed: "Kod doğrulanamadı. Tekrar dene.",
    invalidCode: "Kod geçersiz veya süresi dolmuş.",
    rateLimited: "Çok fazla deneme yapıldı. Daha sonra tekrar dene.",
    title: 'Kodu gir',
    sentTo: '{phone} numarasına SMS gönderdik',
    verify: 'Doğrula',
    resend: 'Tekrar gönder',

    tooManyAttempts: 'Çok fazla deneme yapıldı. Biraz bekleyip tekrar dene.',

    resendSent: 'Yeni kod gönderildi.',
    resendFailed: 'Kod gönderilemedi. Bağlantını kontrol edip tekrar dene.',
    resendWait: '{n} sn sonra tekrar isteyebilirsin',
  },
  university: {
    title: 'Üniversiten hangisi?',
    subtitle: 'Üniversiteni ara',
    placeholder: 'Harvard, Boğaziçi…',
    skip: 'Atla',
  },
  profession: {
    title: 'Ne iş yapıyorsun?',
    subtitle: 'Mesleğini arayarak bul',
    placeholder: 'Öğretmen, yazılımcı, hemşire…',
    skip: 'Atla',
  },
  // ISCO-08 ana grupları (meslek kovaları) — keşif filtresi + picker alt satırı.
  isco: {
    '0': 'Silahlı kuvvetler',
    '1': 'Yöneticiler',
    '2': 'Profesyoneller',
    '3': 'Teknisyenler & yardımcı profesyoneller',
    '4': 'Büro destek',
    '5': 'Hizmet & satış',
    '6': 'Tarım, ormancılık & balıkçılık',
    '7': 'Zanaat & ilgili işler',
    '8': 'Tesis & makine operatörleri',
    '9': 'Nitelik gerektirmeyen işler',
  },
  // ISCED (UNESCO) eğitim seviyeleri — küresel standart.
  isced: {
    '5': 'Ön lisans',
    '6': 'Lisans',
    '7': 'Yüksek lisans',
    '8': 'Doktora',
  },
  profileCreate: {
    photoPickerFailed: "Fotoğraf arşivi açılamadı.",
    title: 'Profilini oluştur',
    addPhoto: 'Fotoğraf ekle',
    name: 'Adın',
    surname: 'Soyadın',
  },
  terms: {
    title: 'Başlamadan önce',
    age: '18 yaşından büyüğüm',
    accept: 'Kullanım Koşulları ve Gizlilik Politikası’nı okudum, kabul ediyorum',
    termsLink: 'Kullanım Koşulları',
    privacyLink: 'Gizlilik Politikası',
    continue: 'Kabul et ve devam et',
    saveFailed: 'Onayın kaydedilemedi. Bağlantını kontrol edip tekrar dene.',
    docPlaceholder: 'Bu belge yakında yayınlanacak.',
  },
  locationConsent: {
    title: 'Konum, yalnız sen istersen',
    body: 'Fotoğraf çektiğinde ilçe ve şehir bilgisini önerebilmemiz için konum iznine ihtiyacımız var.',
    privacy: 'Bu adım konumunu okumaz. Konum yalnız başarılı bir çekimden sonra kullanılır; kesin koordinatın saklanmaz. İzni daha sonra cihaz ayarlarından değiştirebilirsin.',
    allow: 'Konuma izin ver',
    later: 'Şimdi değil',
  },
  discover: {
    title: "Keşfet",
    categories: "Meslek kategorileri",
    categoryHint: "Profillerde paylaşılan mesleklere göre kişileri keşfet.",
    all: "Tümü",
    reset: "Filtreleri temizle",
    failed: 'Yüklenemedi',
    free: 'Ücretsiz',
    empty: 'Henüz kimse yok',
  },
  userProfile: {
    smsVerifiedOn: "Telefon SMS ile doğrulandı · {date}",
    googleLinkedOn: "Google hesabı bağlandı · {date}",
    contactProofNote: "Telefon veya Google hesabına erişimi gösterir; kişinin kimliğini doğrulamaz.",
    failed: 'Profil yüklenemedi.',
    sendMessage: 'Mesaj gönder',
    buyTime: 'Buluşma teklif et',
    block: 'Engelle',
    blockedNotice: '{name} engellendi. Mesajlaşma, arama ve buluşma kullanılamıyor.',
    blockTitle: '{name} engellensin mi?',
    blockMessage: 'Bu kişi sana mesaj gönderemez ve seni Keşfet bölümünde göremez.',
    blockConfirm: 'Engelle',
  },
  callHistory: {
    empty: 'Henüz arama yok',
    tabAll: 'Tümü',
    tabMissed: 'Cevapsız',
    emptyMissed: 'Cevapsız çağrı yok',
    failed: 'Aramalar yüklenemedi',
    outgoing: 'Giden',
    incoming: 'Gelen',
    missed: 'Cevapsız',
    declined: 'Reddedildi',
    cancelled: 'İptal edildi',
  },
  call: {
    title: 'Sesli arama',
    calling: 'Aranıyor…',
    incoming: 'Gelen arama',
    connecting: 'Bağlanıyor…',
    connected: 'Bağlandı',
    reconnecting: 'Yeniden bağlanıyor…',
    logAnswered: 'Sesli arama',
    logAnsweredVideo: 'Görüntülü arama',
    logNoAnswer: 'Cevap verilmedi',
    logMissed: 'Cevapsız çağrı',
    logDeclined: 'Çağrı reddedildi',
    logYouDeclined: 'Çağrıyı reddettin',
    logCancelled: 'Çağrı iptal edildi',
    ended: 'Çağrı sona erdi',
    accept: 'Cevapla',
    decline: 'Reddet',
    hangUp: 'Kapat',
    close: 'Kapat',
    mute: 'Mikrofonu kapat',
    unmute: 'Mikrofonu aç',
    cameraOff: 'Kamerayı kapat',
    cameraOn: 'Kamerayı aç',
    flipCamera: 'Kamerayı çevir',
    audioOutput: 'Ses çıkışı: {route}',
    audioOutputTitle: 'Ses çıkışını seç',
    earpiece: 'Ahize',
    speaker: 'Hoparlör',
    bluetooth: 'Bluetooth',
    bluetoothPermissionDenied: 'Bluetooth izni kapalı. Ayarlardan aç.',
    micPermission: 'Arama için mikrofon izni gerekli. Ayarlardan aç.',
    micPermissionWeb: 'Arama için mikrofon izni gerekli. Tarayıcının site ayarlarından izin ver.',
    wiredHeadset: 'Kablolu kulaklık',
    audioRouteFailed: 'Ses çıkışı değiştirilemedi',
    acceptFailed: 'Çağrı cevaplanamadı. Tekrar dene.',
    declineFailed: 'Çağrı reddedilemedi. Tekrar dene.',
    endFailed: 'Çağrı kapatılamadı. Tekrar dene.',
    mediaConnectionFailed: 'Ses bağlantısı kurulamadı. Çağrı ücretlendirilmeden kapatıldı.',
    remaining: 'Kalan {time}',
    endingSoon: 'Arama yakında sona erecek.',
    spent: '{amount} harcandı',
    earned: '{amount} kazanıldı',
    noAudioNotice: 'Bu sürüm henüz ses aktarmıyor. Arama akışı ve ücretlendirme test ediliyor.',
    failed: 'Çağrı başlatılamadı',
    insufficient: 'Bakiyen bu çağrı için yetersiz',
    busy: 'Karşı taraf şu anda meşgul',
    notAllowed: 'Arayabilmek için aranızda en az bir mesaj bulunmalı.',
    notAccepting: 'Bu kişi şu anda arama kabul etmiyor',
    priceFree: 'Ücretsiz',
    priceChanged: 'Arama ücreti değişti. Güncel ücreti görüp tekrar dene.',
    rateLimited: 'Çok sık arama yaptın. Biraz bekleyip tekrar dene.',
    reservationLinkUnavailable: 'Bu rezervasyon artık bu çağrıya bağlanamıyor. İstersen rezervasyondan bağımsız bir çağrı başlatabilirsin.',

    missed: 'Cevapsız çağrı',
    callNow: 'Şimdi ara',
    videoNow: 'Görüntülü ara',
    scheduledStartTitle: 'Planlı arama',
    scheduledStartBody: '{name} ile planlı araman başlıyor. Şimdi aransın mı?',
    schedule: 'Arama planla',
    scheduleTitle: '{name} ile arama planla',
    subjectPlaceholder: 'Konu (isteğe bağlı)',
    priceNote: 'Arama ücreti: {price}',
    sendReservation: 'Rezervasyon talebi gönder',
    reservationSent: 'Talep gönderildi',
    reservationSentBody: '{name} kişisine arama rezervasyonu talebin iletildi.',
    reservationFailed: 'Arama rezervasyonu talebi gönderilemedi.',
    reservationBubble: '☎️ Arama rezervasyonu talep edildi',
    reservationBubbleShort: '☎️ Arama rezervasyonu',
    reservationLabel: 'Sesli arama rezervasyonu',
    rescheduleBubble: '☎️ Yeni arama saati önerildi',
    rescheduleBubbleShort: '☎️ Yeni arama saati',
  },
  wallet: {
    otherAmount: "Diğer",
    customAmount: "Tutar",
    customAmountHint: "En fazla {amount}; en çok iki ondalık basamak.",
    title: 'Cüzdan',
    failed: 'Cüzdan yüklenemedi',
    availableBalance: 'Kullanılabilir bakiye',
    earningsTitle: 'Kazançlarım',
    earningsTotal: 'Toplam kazanılan',
    earningsWithdrawable: 'Çekilebilir tutar',
    earningsEscrow: 'Emanette bekleyen',
    addFunds: 'Para yükle',
    addFundsDemo: 'Demo: hesabına test bakiyesi ekle',
    addFundsFailed: 'Para yüklenemedi.',
    topupLabel: 'Para yüklendi',
    transactions: 'İşlemler',
    noTransactions: 'Henüz işlem yok',
    waiting: 'bekliyor',
    incomingRequest: 'gelen talep',
    replied: 'yanıtladı',
    earned: 'kazanıldı',
    refunded: 'İade edildi',
    requestPayout: 'Para çek',
    payoutHint: 'En fazla {amount} çekebilirsin.',
    payoutAll: 'Tüm tutarı seç',
    payoutRequested: 'Talebin alındı',
    payoutRequestedBody: '{amount} çekim talebi oluşturuldu, en kısa sürede işlenecek.',
    payoutFailed: 'Çekim talebi oluşturulamadı.',
    payoutRequests: 'Çekim talepleri',
    noPayouts: 'Henüz çekim talebi yok',
    payoutStatusPending: 'Bekliyor',
    payoutStatusPaid: 'Ödendi',
    payoutStatusRejected: 'Reddedildi',
    paymentAccount: 'Ödeme hesabı',
    stripeConnect: 'Ödeme hesabını bağla',
    stripeConnectInfo: 'Kazancını almak için banka hesabını bağla (Stripe, test modu)',
    stripeConnected: 'Bağlandı',
    stripeConnectFailed: 'Bağlantı kurulamadı.',
  },
  calendar: {
    dateInputLabel: "Tarih",
    timeInputLabel: "Saat",
    dateInputHint: "Yılı, ayı ve günü YYYY-MM-DD biçiminde yaz.",
    timeInputHint: "Saati 24 saatlik HH:MM biçiminde yaz.",

    previousWeek: 'Önceki hafta',
    nextWeek: 'Sonraki hafta',
    empty: 'Gösterilecek istek yok',
    failed: 'Takvim yüklenemedi',
    statusPending: 'Bekliyor',
    statusAccepted: 'Onaylandı',
    statusDeclined: 'Reddedildi',
    statusCancelled: 'İptal edildi',
    statusExpired: 'Süresi doldu',
    accept: 'Kabul et',
    decline: 'Reddet',
    cancel: 'İptal et',
    cancelConfirmationTitle: 'Rezervasyon iptal edilsin mi?',
    cancelConfirmationAcceptedBody: '{name} ile onaylanmış rezervasyon iptal edilecek. Karşı taraf bilgilendirilecek ve işlem geri alınamayacak.',
    cancelConfirmationPendingBody: '{name} kişisine gönderilen teklif geri çekilecek. Karşı taraf bilgilendirilecek ve işlem geri alınamayacak.',
    actionFailed: 'İşlem başarısız.',
    proposeTitle: '{name} ile buluşma öner',
    locationPlaceholder: 'Nerede? (isteğe bağlı)',
    sendProposal: 'Teklifi gönder',
    proposalSent: 'Teklif gönderildi',
    proposalSentBody: '{name} kişisine buluşma teklifin iletildi.',
    priceChangedBody: 'Bu rezervasyonun dakika ücreti artık {amount}. Teklif oluşturulmadı; yeni ücreti görüp tekrar teklif edebilirsin.',
    proposalFailed: 'Teklif gönderilemedi.',
    meetupBubble: '📅 Buluşma teklif edildi',
    meetupBubbleShort: '📅 Buluşma teklifi',
    proposeAction: '📅 Buluşma teklif et',
    priceNote: 'Buluşma ücreti: {price}',
    totalCost: 'Toplam: {amount}',
    minutesShort: 'dk',
    tabRequests: 'İstekler',
    tabCalendar: 'Takvim',
    tabActive: 'Güncel',
    tabHistory: 'Geçmiş',
    loadMore: 'Daha fazla göster',
    noEventsForDay: 'Bu günde etkinlik yok',
    meetupLabel: 'Fiziksel buluşma',
    reservationDetails: 'Rezervasyon ayrıntıları',
    reservationParticipant: 'Kişi',
    reservationHeld: 'Arama yapıldı',
    reservationNotHeld: 'Arama yapılmadı',
    reservationDateTime: 'Tarih ve saat',
    reservationDuration: 'Süre',
    reservationRate: 'Dakika başına',
    reservationLocation: 'Konum',
    reservationSubject: 'Konu',
    reservationQuotedTotal: 'Teklif toplamı',
    reservationBilledDuration: 'Ücretlendirilen süre',
    reservationSpentAmount: 'Ödediğin tutar',
    reservationEarnedAmount: 'Kazandığın tutar',
    reservationSettledAt: 'Mahsuplaştırıldı',
    reservationCreated: 'Oluşturuldu',
    reservationResponded: 'Yanıtlandı',
    reservationAcceptedAt: 'Onaylandı',
    reservationDeclinedAt: 'Reddedildi',
    reservationCancelledAt: 'İptal edildi',
    reservationCancelledBy: 'İptal eden',
    reservationYou: 'Sen',
    reservationCancellationNotification: 'Bildirim gönderimi',
    reservationNotificationPending: 'Hazırlanıyor',
    reservationNotificationProviderAccepted: 'Gönderim sağlayıcısı kabul etti',
    reservationNotificationSuppressed: 'Bildirim tercihi nedeniyle gönderilmedi',
    reservationNotificationUnavailable: 'Gönderilecek cihaz bulunamadı',
    reservationPendingReschedule: 'Önerilen yeni saat',
    reservationNewTime: 'Yeni tarih ve saat',
    proposeNewTime: 'Yeni saat öner',
    rescheduleFuture: 'Yeni başlangıç saati gelecekte olmalı ve planlanmış başlangıç saatinden en az bir dakika farklı olmalı.',
    reservationCallTooEarly: 'Bu planlı arama, başlangıçtan 15 dakika önce açılır.',
    reservationCallExpired: 'Bu rezervasyonun arama penceresi sona erdi.',
    reservationCallInProgress: 'Bu rezervasyona bağlı arama zaten başlatıldı.',
    reservationExecutionLocked: 'Başlamış veya sonuçlanmış bu planlı arama artık değiştirilemez.',
    openReservation: '{name} ile rezervasyon ayrıntılarını aç',
    systemEventMeetupTitle: '{name} ile buluşma',
    systemEventCallTitle: '{name} ile planlı arama',
    systemEventNotes: 'nosubject üzerinden onaylandı.',
    systemCalendarCopyRemoved: 'Sistem takvimi kopyası silindi',
    restoreSystemCalendarCopy: 'Geri yükle',
    systemCalendarRestoreFailed: 'Takvim kopyası geri yüklenemedi. Takvim bağlantılarını ve sistem iznini kontrol et.',
    systemCalendarCopyChanged: 'Sistem takvimi zamanı değiştirildi',
    reviewSystemCalendarChange: 'İncele',
    systemCalendarChangeTitle: 'Takvim zamanı değiştirildi',
    systemCalendarChangeBody: 'Bu değişiklik karşı tarafa uygulanmadı.\n\nnosubject: {nosubject}\nSistem takvimi: {system}',
    restoreNosubjectTime: 'nosubject zamanına döndür',
    systemCalendarTimeRestoreFailed: 'Takvim kopyasının zamanı düzeltilemedi. Takvim bağlantılarını ve sistem iznini kontrol et.',
    proposeReschedule: 'Karşı tarafa öner',
    rescheduleSent: 'Yeni saat önerildi',
    rescheduleSentBody: 'Yeni saat önerin {name} kişisine gönderildi. Mevcut saat, karşı taraf kabul edene kadar korunur.',
    rescheduleFailed: 'Yeni saat önerilemedi.',
    rescheduleActionFailed: 'Saat önerisi güncellenemedi',
    reschedulePendingReceived: 'Yeni saat önerisi: {time}',
    reschedulePendingSent: 'Yanıt bekleyen yeni saat: {time}',
    withdrawReschedule: 'Öneriyi geri çek',
    rescheduleBubble: '📅 Yeni buluşma saati önerildi',
    rescheduleBubbleShort: '📅 Yeni buluşma saati',
    connectionsTitle: 'Takvim bağlantıları',
    connectionsInfo: 'Görmek istediğin takvimleri seç',
    deviceCalendar: 'Cihaz takvimleri',
    connect: 'Bağla',
    openSettings: 'Ayarları aç',
    permissionGranted: 'Erişim verildi',
    permissionDenied: 'Erişim kapalı',
    permissionUnavailable: 'Bu sürümde kullanılamıyor',
    permissionNotRequested: 'Henüz bağlanmadı',
    devicePermissionInfo: 'İzin yalnızca sen bu düğmeye dokunduğunda istenir. nosubject seçtiğin takvimleri ve gerekli zaman aralığını okur; bu ekrandan etkinlik yazmaz.',
    selectCalendars: 'Gösterilecek takvimler',
    noDeviceCalendars: 'Cihazda kullanılabilir etkinlik takvimi bulunamadı.',
    manageSystemPermission: 'Sistem takvim iznini yönet',
    connectionPrivacyInfo: 'Seçim bu cihazda ve bu nosubject hesabı için saklanır. Dış etkinlik ayrıntıları yalnız kendi takvim görünümünde kullanılır; başka kişilerle otomatik olarak paylaşılmaz.',
    newBuildRequired: 'Takvim bağlantıları için uygulamanın yeni sürümü gereklidir.',
    connectionFailed: 'Takvim bağlantısı kurulamadı.',
    disconnect: 'Bağlantıyı kaldır',
    disconnectTitle: 'Takvim bağlantısı kaldırılsın mı?',
    disconnectBody: 'nosubject bu cihazdaki takvimleri okumayı ve yeni onaylanan etkinlikleri yazmayı durduracak. Seçimler ve yerel eşlemeler silinir; sistem takvimindeki mevcut etkinlikler kalır. Sistem iznini ayrıca cihaz ayarlarından kapatabilirsin.',
    disconnectFailed: 'Takvim bağlantısı kaldırılamadı.',
    selectionSaveFailed: 'Takvim seçimi kaydedilemedi.',
    allDay: 'Tüm gün',
    recurring: 'Yineleniyor',
    availabilityFree: 'Serbest',
    availabilityBusy: 'Meşgul',
    availabilityTentative: 'Geçici',
    availabilityUnavailable: 'Uygun değil',
    untitledExternalEvent: 'Başlıksız etkinlik',
    externalEventsFailed: 'Dış takvim etkinlikleri yüklenemedi.',
    hideExternalEvent: '{title} etkinliğini bu görünümden gizle',
    hideExternalEventFailed: 'Etkinlik gizlenemedi.',
    restoreHiddenExternalEvents: 'Gizlenen etkinlikleri yeniden göster',
    restoreHiddenExternalEventsFailed: 'Gizlenen etkinlikler yeniden gösterilemedi.',
    hiddenExternalEventCount: '{count} etkinlik bu cihazda gizli',
    checkIncompleteTitle: 'Takvim kontrolü tamamlanamadı',
    checkIncompleteBody: 'En az bir takvim kaynağı geçici olarak okunamadı. Bu nedenle bu saatin tamamen uygun olduğunu doğrulayamıyoruz. İstersen yine de devam edebilirsin.',
    conflictCheckIncomplete: 'Bazı takvimler okunamadığı için başka çakışmalar da olabilir.',
    conflictTitle: 'Takvim çakışması',
    reservationUnavailable: 'Bu saat başka bir onaylanmış rezervasyon nedeniyle artık uygun değil.',
    reservationChanged: 'Bu rezervasyon başka bir ekran veya cihazda değişti. Güncel hâlini yükledik.',
    reservationPast: 'Başlangıç zamanı geçmiş bir rezervasyon kabul edilemez.',
    conflictBody: 'Bu zaman, takvimindeki başka bir etkinlikle çakışıyor. İstersen yine de devam edebilirsin.',
    tentativeConflictTitle: 'Geçici takvim etkinliği',
    tentativeConflictBody: 'Bu saatteki bir takvim etkinliği henüz kesinleşmemiş. Devam etmeden önce ayrıntıları kontrol et.',
    conflictMore: '• Diğer etkinlikler: {count}',
    continueAnyway: 'Yine de devam et',
    onlineCalendars: 'Çevrimiçi takvimler',
    googleCalendar: 'Google Takvim',
    providerConnected: 'Bağlandı',
    providerNotConnected: 'Bağlı değil',
    providerUnavailable: 'Resmî bağlantı kurulumu hazırlanıyor',
    googlePrivacyInfo: 'Yalnız seçtiğin takvimler eşitlenir. Başlık ve konum asgari sunucu önbelleğinde şifreli tutulur; açıklama, katılımcılar ve konferans bağlantıları saklanmaz. nosubject Google Takvim etkinliklerini oluşturamaz, değiştiremez veya silemez.',
    googleConnectionFailed: 'Google Takvim bağlantısı başlatılamadı.',
    microsoftCalendar: 'Microsoft Takvim',
    microsoftInfo: 'nosubject yalnız uygunluğunu okur (Calendars.Read). Etkinlik oluşturamaz, değiştiremez veya silemez. Erişimi kaldırmak Microsoft hesap ayarlarından yapılır; nosubject bunu kendi başına iptal edemez.',
    microsoftConnectionFailed: 'Microsoft Takvim bağlantısı başlatılamadı.',
    googleDisconnectTitle: 'Google Takvim bağlantısı kaldırılsın mı?',
    googleDisconnectBody: 'nosubject, Google Takvim verilerine erişmeyi durduracak ve nosubject için verdiğin Google izinlerini kaldıracak. Google Takvimindeki etkinlikler silinmez.',
    googleDisconnectFailed: 'Google Takvim bağlantısı kaldırılamadı.',
    googleNoCalendars: 'Okunabilir bir Google takvimi bulunamadı.',
    googleSelectionSaveFailed: 'Google Takvim seçimi kaydedilemedi.',
  },
  instagram: {
    title: 'Instagram bağlantısı',
    connectInfo: 'Profesyonel hesabını açık izinle bağla',
    connectedAccounts: 'Bağlı hesaplar',
    professionalAccount: 'Profesyonel hesap',
    connect: 'Bağla',
    reconnect: 'Yeniden bağla',
    connectedAs: '@{username} · {accountType}',
    notConnected: 'Henüz bağlanmadı',
    unavailable: 'Resmî bağlantı kurulumu hazırlanıyor',
    privacyInfo: 'İlk aşama yalnız profesyonel hesap kimliğini okumak için instagram_business_basic iznini ister. Mesaj, yorum veya yayımlama izni istenmez; fotoğraflar ayrıca içe aktarmayı seçmeden nosubject’e kopyalanmaz.',
    business: 'İşletme',
    creator: 'İçerik üreticisi',
    connectionFailed: 'Instagram bağlantısı başlatılamadı.',
  },
  inbox: {
    markUnread: 'Okunmadı olarak işaretle',
    markRead: 'Okundu olarak işaretle',
    archiveTitle: 'Arşiv',
    archive: 'Arşiv',
    failed: 'Konuşmalar yüklenemedi',
    searchEmpty: 'Sonuç bulunamadı',
    archivedEmpty: 'Arşivlenen konuşma yok',
    empty: 'Henüz konuşma yok',
    you: 'Sen:',
    archived: 'Arşivlendi',
    unarchived: 'Arşivden çıkarıldı',
    undo: 'Geri al',
    mute: 'Bildirimleri sessize al',
    muteTitle: '{name} · Bildirimleri sessize al',
    mute1h: '1 saat',
    mute8h: '8 saat',
    mute1w: '1 hafta',
    muteForever: 'Süresiz',
    unmute: 'Bildirimlerin sessizliğini kaldır',
    archiveAction: 'Arşivle',
    unarchiveAction: 'Arşivden çıkar',
    swipeRemove: 'Arşivden çıkar',
    swipeArchive: 'Arşivle',
    blockAction: 'Engelle',
    blockTitle: '{name} engellensin mi?',
    blockMessage: 'Bu kişi sana mesaj gönderemez ve seni Keşfet bölümünde göremez.',
    blockConfirm: 'Engelle',
  },
  // 9.33.9.3 / D-780 — passkeys, named as the system names them.
  passkeys: {
    // D-882 — signing in with a passkey.
    signIn: "Geçiş anahtarıyla giriş yap",
    signInIntro: "Geçiş anahtarınla telefon numarası ya da kod girmeden giriş yapabilirsin.",
    signInNone: "Bu cihazda nosubject için geçiş anahtarı yok. Önce telefon numaranla giriş yap, sonra Profil → Ayarlar → Giriş yöntemleri → Geçiş anahtarları’ndan ekle.",
    signInFailed: "Geçiş anahtarıyla giriş yapılamadı. Tekrar dene.",
    // D-876 — a lost passkey, reset after a 48-hour wait.
    lost: "Geçiş anahtarını mı kaybettin?",
    recoveryIntro: "Geçiş anahtarın artık hiçbir cihazında yoksa sıfırlayabilirsin. Numaranı doğruladıktan sonra 48 saat beklenir. Bunu sohbetinde sana bildiririz; geçiş anahtarına sahip olan sıfırlamayı iptal edebilir.",
    recoveryPending: "Sıfırlama {date} tarihinde hazır olacak.",
    recoveryCancel: "Sıfırlamayı iptal et",
    recoveryCancelled: "Sıfırlama iptal edildi.",
    recoveryReady: "Sıfırlama hazır. Yeni geçiş anahtarını ekle.",
    recoveryDone: "Yeni geçiş anahtarın eklendi. Eskileri artık çalışmıyor.",
    title: "Geçiş anahtarları",
    intro: "Geçiş anahtarı, bu cihazın kilidini nasıl açıyorsan seni öyle doğrular. Cihazında kalır; yüzün ya da parmak izin nosubject’e hiç gelmez.",
    taskIntro: "nosubject’in resmî hesabına yazdığın mesajlar gönderilmeden önce geçiş anahtarıyla onaylanır.",
    empty: "Henüz geçiş anahtarın yok.",
    add: "Geçiş anahtarı ekle",
    remove: "Kaldır",
    removeTitle: "Bu geçiş anahtarı kaldırılsın mı?",
    removeBody: "Önce bir geçiş anahtarıyla onaylayacaksın.",
    added: "Geçiş anahtarı eklendi.",
    removed: "Geçiş anahtarı kaldırıldı.",
    addedOn: "Eklendi: {date}",
    lastUsed: "Son kullanım: {date}",
    unnamed: "Geçiş anahtarı",
    reauthIntro: "İlk geçiş anahtarını eklemek için kayıtlı telefon numaranı doğrula.",
    sendCode: "Doğrulama kodu gönder",
    codeSent: "{phone} ile biten kayıtlı numarana kod gönderildi.",
    codeLabel: "Doğrulama kodu",
    startAgain: "Baştan başla",
    wrongCode: "Bu kod olmadı. Yeni bir kod gönder.",
    failed: "İşlem tamamlanamadı. Tekrar dene.",
    exists: "Bu cihazda hesabın için zaten bir geçiş anahtarı var.",
    unsupportedApp: "Uygulamanın bu sürümü henüz geçiş anahtarı kullanamıyor. Bir sonraki uygulama güncellemesiyle gelecek.",
    unsupportedWeb: "Bu tarayıcı geçiş anahtarı kullanamıyor.",
    tapTitle: "Geçiş anahtarınla devam et",
    tapAction: "Devam et",
  },
  message: {
    jumpLatest: 'En yeni mesaja git',
    info: "Mesaj bilgisi",
    infoSentAt: "Gönderilme",
    infoReadAt: "Okunma",
    infoPlatform: "Gönderilen platform",
    // 9.33.9.4 — a message to the task chat stopped for its passkey.
    passkeyNeededTitle: "Önce geçiş anahtarı ekle",
    passkeyNeededBody: "Bu hesaba giden mesajlar geçiş anahtarıyla onaylanır. Bir tane ekle, sonra yeniden gönder.",
    passkeyUnavailable: "Bu mesaj geçiş anahtarını istiyor; uygulamanın bu sürümü onu henüz kullanamıyor. nosubject.co’dan ya da bir sonraki güncellemeden sonra gönder.",
    passkeyFailed: "Mesaj onaylanamadı, bu yüzden gönderilmedi.",
    forwardOwn: "İlet",
    forwardHint: "Bir sohbet seç. Metin taslak olarak açılır; gönderim ve güncel ücret onayı ayrıca gerekir.",
    forwardMediaHint: "Bir sohbet seç. Ayrı bir medya taslağı açılır; ücreti kontrol edip Gönder’e dokun. Açıklama ve konum kopyalanmaz.",
    forwardMediaWaiting: "Hazırlık henüz doğrulanmadı. Tekrar denemek aynı işlemi kontrol eder; mesaj göndermez.",
    forwardMediaUnavailable: "Medya işlemi doğrulanamadı. Tekrar göndermeden önce sohbeti kontrol et.",
    forwardEmpty: "Başka açık sohbet yok.",
    forwardDraftFirst: "Önce mevcut taslağı gönder veya temizle.",
    translationLanguage: "Çeviri dili",
    chooseTranslationLanguage: "Çeviri dilini seç",
    languageSuggestion: "Cihaz dili önerisi",
    translationLanguageInfo: "Bu özel tercih tüm konuşmalarındaki çeviriler için kullanılır. Profiline eklenmez.",
    photoCaption: "Fotoğrafa açıklama ekle…",
    removePhoto: "Fotoğrafı kaldır",
    star: "Yıldız ekle",
    unstar: "Yıldızı kaldır",
    starred: "Yıldızlı mesajlar",
    noStars: "Bu sohbette yıldızlı mesaj yok.",
    starFailed: "Yıldızlar güncellenemedi. Tekrar deneyin.",
    starredAttachment: "Ekli mesaj",
    edit: "Mesajı düzenle",
    edited: "Düzenlendi",
    editInfo: "Okundu bilgisi kapalı olsa da mesaj okunana kadar düzenleyebilirsin. Düzenle seçeneğinin kaybolması, mesajın okunduğunu belli edebilir. Okunmadı, hiç görülmedi demek değildir: ilk metin bildirim önizlemesinde görülmüş olabilir. Düzenleme, sözünü geri alma garantisi vermez.",
    editFailed: "Düzenleme doğrulanamadı. Mesaj okunmuş veya değişmiş olabilir. Tekrar denemeden önce sohbeti kontrol et.",
    copy: "Kopyala",
    copyFailed: "Mesaj kopyalanamadı. Tekrar dene.",
    inputPlaceholder: 'Mesaj yaz…',
    typing: 'Yazıyor',
    translate: 'Çevir',
    withdrawn: 'Mesaj geri çekildi',
    linkOpenTitle: 'Bağlantıyı aç',
    linkOpenBody: '{host} adresine gideceksin. Bu bağlantıyı sana mesajı yazan kişi gönderdi; tanımıyorsan dikkatli ol.',
    linkOpenConfirm: 'Aç',
    linkOpenFailed: 'Bağlantı açılamadı.',
    seenAt: 'Görüldü {time}',

    priceChangedTitle: 'Fiyat değişti',
    priceChangedBody: 'Bu mesajın fiyatı {old} değil {new}. Yine de gönderilsin mi?',
    priceChangedSend: 'Gönder',
    priceNoticeTitle: 'Bu kişiyle konuşmanın ücreti',
    priceNoticeMessage: 'Mesaj başına {amount}',
    priceNoticeCall: 'Arama {amount}',
    priceNoticePersonal: 'Bu ücretler sana özel belirlenmiş.',
    priceDecreasedTitle: "Mesaj fiyatı düştü",
    priceDecreasedBody: "Mesaj ücreti {old} yerine artık {new}. Yeni fiyat için onay gerekmiyor.",
    priceChange: {
      free: 'ücretsiz',
    },
    expired: 'süresi doldu, iade edildi',
    // 9.2 / D-650 — web'den gönderilen mesajın saat satırındaki notu.
    sentFromWeb: 'web’den',
    linkViewLabel: 'Link görünümü',
    linkViewPlain: 'Açık adres',
    linkViewCompact: 'Kısa',
    linkViewCard: 'Büyük kart',
    linkPreviewLoading: 'Önizleme hazırlanıyor…',
    linkPreviewFailed: 'Bu link için önizleme alınamadı; açık adres olarak gidecek.',
    linkPreviewA11y: 'Bağlantı: {title}, {host}',
    customPrice: 'Özel fiyat',
    priceUsesGeneral: 'Genel fiyatım geçerli',
    priceRemove: 'Kişilerimden çıkar',
    priceRemoveTitle: '{name} kişilerinden çıkarılsın mı?',
    priceRemoveBody: 'Kişiye özel fiyat kaldırılacak; {name} için belirlediğin genel fiyat geçerli olacak. Yalnız kişilerinin yazmasına izin veriyorsan bu kişi artık yeni bir konuşma başlatamaz. Bu işlem kişiyi engellemez.',
    priceRemoveConfirm: 'Çıkar',
    priceRemoved: '{name} için artık belirlediğin genel fiyat geçerli.',
    pricePrompt: '{name} için fiyatlar (0 = ücretsiz):',
    saved: 'Kaydedildi',
    priceFreeSet: '{name} artık sana ücretsiz yazabilir.',
    priceSet: '{name} için fiyat {price} olarak ayarlandı.',
    saveError: 'Kaydedilemedi.',
    photoError: 'Fotoğraf gönderilemedi.',
    noConnection: 'Bağlantı yok',
    checkInternet: 'İnternet bağlantını kontrol et.',
    sendError: 'Mesaj gönderilemedi.',
    addAttachment: 'Ek ekle',
    sendMessageAction: 'Mesaj gönder',
    lowBalanceTitle: 'Yetersiz bakiye',
    lowBalanceBody: 'Cüzdan bakiyen bu kişinin mesaj ücretinin altında. Para yükleyip tekrar dene.',
    reply: 'Yanıtla',
    reactionA11y: '{emoji} tepkisi, toplam {count}',
    reactionA11yMine: '{emoji} tepkisi, toplam {count}, biri senin',
    reactionAdd: '{emoji} ile tepki ver',
    moreReactions: 'Diğer emojiler',
    reactionRemove: '{emoji} tepkini kaldır',
    you: 'Sen',
    photo: '📷 Fotoğraf',
    takePhoto: 'Fotoğraf çek',
    choosePhoto: 'Galeriden seç',
    chooseVideo: 'Video seç',
    recordVoice: 'Ses kaydı',
    micPermissionTitle: 'Mikrofon izni gerekli',
    micPermissionBody: 'Ses kaydı için mikrofon iznini açman gerekiyor.',
    voiceError: 'Ses kaydı gönderilemedi.',
    voiceRecording: 'Kaydediliyor',
    videoTooLarge: 'Video çok büyük (en fazla 1 GB)',
    videoTooLong: 'Video çok uzun (en fazla 10 dakika)',
    videoError: 'Video gönderilemedi.',
    videoNeedsUpdate: 'Bu videoyu izlemek için uygulamayı güncelle',
    voiceNeedsUpdate: 'Bu ses mesajını dinlemek için uygulamayı güncelle',
    voiceOrderTitle: 'Ses mesajı ısmarlandı',
    encrypted: 'Şifreli mesaj',
    identityChanged: 'Bu kişinin güvenlik anahtarı değişti. Genellikle yeni bir telefon ya da yeniden kurulan uygulama demektir.',
    identityChangedVerify: 'Bu sohbeti doğrulamıştın; güvenlik numarasını yeniden karşılaştır.',
    unencrypted: 'Bu konuşma şifreli değil',
    unencryptedPeerInfo: 'Karşı tarafın uygulaması uçtan uca şifrelemeyi henüz desteklemiyor. Bu yüzden buraya yazdıkların şifrelenmeden gider ve nosubject sunucusunda okunabilir. Karşı taraf uygulamasını güncellediğinde yeni mesajlar kendiliğinden şifreli gider.',
    unencryptedOfficialInfo: 'Bu, nosubject’in resmî hesabı. Buraya yazdıkların şifrelenmeden gider ve nosubject ekibi tarafından okunabilir.',
    unencryptedSelfInfo: 'Bu cihazda şifreleme açılamadı (ör. tarayıcının gizli penceresi anahtar saklayamaz). Buradan gönderdiklerin şifrelenmeden gider ve nosubject sunucusunda okunabilir.',
    notificationOfferEnable: 'Bildirimleri aç',
    notificationOfferEnabled: 'Bildirimler açık',
    voiceOrderPending: 'Teslim bekleniyor',
    voiceOrderDelivered: 'Teslim edildi',
    voiceOrderDeclined: 'Reddedildi, iade edildi',
    voiceOrderExpired: 'Süresi doldu, iade edildi',
    voiceOrderAction: 'Ses kaydı ısmarla',
    voiceOrderPick: 'Ne kadarlık bir kayıt?',
    voiceOrderInsufficient: 'Bakiyen bu siparişe yetmiyor.',
    voiceOrderError: 'Sipariş verilemedi.',
    voiceOrderRecord: 'Kaydet ve gönder',
    voiceOrderDecline: 'Reddet',
    voiceOrderDeclineTitle: 'Siparişi reddet',
    voiceOrderDeclineBody: 'Ayrılan paranın tamamı ısmarlayana geri döner.',
    voiceOrderDeclineError: 'Sipariş reddedilemedi.',
    voiceOrderDeliverError: 'Kayıt teslim edilemedi.',
    voiceOrderRecording: 'Sipariş kaydı',
    voiceOrderRemaining: 'Kalan süre {length}',
    voiceOrderShortNote: 'Daha kısa gönderirsen yalnız kaydettiğin kadarı ödenir.',
    voiceOrderRefunded: '{amount} geri ödendi',
    sendLocation: 'Konum gönder',
    locationTitle: 'Konum',
    locationError: 'Konum gönderilemedi.',
    shareLiveLocation: 'Canlı konum paylaş',
    liveLocationHour: '1 saat',
    liveLocationEightHours: '8 saat',
    liveLocationOpenEnded: 'Ben durdurana kadar',
    liveLocationSharing: 'Canlı konumun paylaşılıyor',
    liveLocationStop: 'Durdur',
    liveLocationError: 'Canlı konum başlatılamadı.',
    liveLocationCardTitle: 'Canlı konum',
    liveLocationCardActive: 'Şu an paylaşılıyor',
    liveLocationCardEnded: 'Paylaşım bitti',
    liveLocationOpen: 'Konumu gör',
    liveLocationNoPoint: 'Henüz konum yok',
    liveLocationOpenInMaps: 'Haritalarda aç',
    locationMapError: 'Harita açılamadı.',
    liveLocationUpdatedAgo: '{ago} güncellendi',
    videoShort: '🎬 Video',
    voiceShort: '🎙 Ses mesajı',
    liveLocationWatchedAgo: '{ago} önce bakıldı',
    liveLocationNotWatched: 'Henüz bakılmadı',
    liveLocationSharerSeesYou: 'Baktığını görebiliyor',
    cameraPermissionTitle: 'Kamera izni gerekli',
    cameraPermissionBody: 'Fotoğraf çekmek için kamera erişimine izin ver.',
    cameraError: 'Kamera açılamadı.',
    photoLocationTitle: 'Fotoğraf konumu',
    photoLocationPromptFile: '{place} bilgisi fotoğraf dosyasından alındı. Konum fotoğrafla birlikte gösterilsin mi?',
    photoLocationPromptCapture: 'Cihaz konumuna göre {place} bulundu. Konum fotoğrafla birlikte gösterilsin mi?',
    photoLocationHide: 'Konumsuz gönder',
    photoLocationShare: 'Konumla gönder',
    photoLocationFromFile: 'Dosyadan alındı',
    photoLocationFromCapture: 'Cihaz konumu',
    photoLocationHideAfter: 'Konumu gizle',
    photoLocationShowAfter: 'Konumu göster',
    photoLocationUpdateError: 'Fotoğraf konumu güncellenemedi.',
  },
  versionNotice: {
    title: 'Yeni sürüm var',
    body: 'Güvenlik ve yeni özellikler için uygulamayı güncelle.',
    update: 'Güncelle',
  },
  notifications: {
    title: 'Bildirimler',
    cardBody: 'Yeni mesajları ve yanıtları kaçırmamak için cihaz bildirimlerini aç.',
    notNow: 'Şimdi değil',
    enable: 'Bildirimleri aç',
    device: 'Cihaz bildirimleri',
    stateOn: 'Açık · Sistem ayarlarından yönet',
    stateOff: 'Kapalı · Sistem ayarlarından aç',
    stateAsk: 'Henüz sorulmadı',
    preferences: 'Bildirim tercihleri',
    preferencesInfo: 'Kategorileri, önizlemeyi ve cihaz iznini yönet',
    stateUnsupported: 'Bu cihazda desteklenmiyor',
    master: 'Tüm bildirimler',
    masterInfo: 'Kapatıldığında kategori seçimlerini silmeden tüm push bildirimlerini durdurur',
    categories: 'Kategoriler',
    categoryEnabled: 'Bu kategoride bildirimler',
    categoryEnabledInfo: 'Kapatıldığında alt seçimleri silmeden bu kategorinin push bildirimlerini durdurur',
    events: 'Olaylar',
    messages: 'Mesajlar',
    messagesInfo: 'Yeni mesaj ve yanıtlar',
    meetups: 'Buluşmalar',
    meetupsInfo: 'Teklifler, değişiklikler ve sonuçlar',
    meetupRequests: 'Yeni buluşma teklifleri',
    meetupRequestsInfo: 'Sana yeni bir buluşma teklifi geldiğinde',
    meetupUpdates: 'Teklif yanıtları ve iptaller',
    meetupUpdatesInfo: 'Buluşma kabul edildiğinde, reddedildiğinde veya iptal edildiğinde',
    meetupReminders: 'Buluşma hatırlatmaları',
    meetupRemindersInfo: 'Onaylanan buluşma yaklaşırken',
    calls: 'Aramalar',
    callsInfo: 'Gelen, planlı ve cevapsız aramalar',
    incomingCalls: 'Gelen aramalar',
    incomingCallsInfo: 'Biri seni aradığında cihazda sesli uyarı',
    callRequests: 'Planlı arama teklifleri',
    callRequestsInfo: 'Yeni teklif, kabul, ret veya iptal olduğunda',
    callReminders: 'Planlı arama hatırlatmaları',
    callRemindersInfo: 'Onaylanan arama yaklaşırken',
    missedCalls: 'Cevapsız aramalar',
    missedCallsInfo: 'Yanıtlayamadığın bir arama olduğunda',
    financial: 'Para ve emanet tutarlar',
    financialInfo: 'İşlem durumu değişiklikleri',
    financialEarnings: 'Kazanç ve emanet tutarlar',
    financialEarningsInfo: 'Emanetteki tutar serbest bırakıldığında veya kazanç oluştuğunda',
    financialRefunds: 'İade ve süre dolması',
    financialRefundsInfo: 'Bir ödeme iade edildiğinde veya emanet süresi dolduğunda',
    financialPayouts: 'Para çekme sonuçları',
    financialPayoutsInfo: 'Para çekme talebi tamamlandığında veya başarısız olduğunda',
    reactions: 'Emoji tepkileri',
    reactionsInfo: 'Mesajlarına verilen tepkiler',
    official: 'Nosubject’ten gelenler',
    officialInfo: 'Nosubject’in sürüm, güvenlik ve hesap duyuruları. Diğer bildirimlerden bağımsızdır; kapatırsan Nosubject bildirim göndermez, mesajları yine gelen kutuna düşer.',
    preview: 'Mesaj önizlemesi',
    previewHidden: 'Gizli',
    previewHiddenInfo: 'Göndereni ve mesajı gösterme',
    previewSender: 'Yalnız gönderen',
    previewSenderInfo: 'Göndereni göster, mesajı gizle',
    previewText: 'Gönderen ve mesaj',
    previewTextInfo: 'En fazla 80 karakter göster',
    deviceInfo: 'İşletim sistemi izni bu cihaza özeldir',
    openSettings: 'Ayarları aç',
    centerTitle: 'Bildirim Merkezi',
    centerMarkAll: 'Tümünü okundu olarak işaretle', centerMarkedAll: 'Tümü okundu olarak işaretlendi',
    centerEmpty: 'Henüz bildirim yok.',
    centerFailed: 'Bildirimler yüklenemedi',
    centerMarkAllFailed: 'Bildirimler okundu olarak işaretlenemedi.',
    centerUnknownPerson: 'Bir kişi',
    centerEscrowExpiredRefunded: 'Emanet süresi doldu · ödeme iade edildi',
    centerEscrowReleasedEarning: 'Cevap tamamlandı · kazanç eklendi',
    centerMeetupRequest: '{name} sana buluşma teklif etti',
    centerCallRequest: '{name} sana planlı arama teklif etti',
    centerCallReminder: '{name} ile planlı araman yaklaşıyor',
    centerCallStarting: '{name} ile planlı araman başlıyor',
    centerMeetupStarting: '{name} ile buluşman başlıyor',
    centerMeetupReminder: '{name} ile buluşman yaklaşıyor',
    centerMeetupUpdate: '{name} · Buluşma {status}',
    centerCallUpdate: '{name} · Planlı arama {status}',
    centerMeetupRescheduleRequest: '{name} yeni bir buluşma saati önerdi',
    centerCallRescheduleRequest: '{name} yeni bir arama saati önerdi',
    centerMeetupRescheduleUpdate: '{name} · Yeni buluşma saati {status}',
    centerCallRescheduleUpdate: '{name} · Yeni arama saati {status}',
    centerBell: 'Bildirim Merkezi',
    centerBellUnread: 'Bildirim Merkezi, okunmamış: {count}',
  },
  profile: {
    viewPhoto: "Profil fotoğrafını aç",
    photoUnavailable: "Fotoğraf yüklenemedi",
    // 9.35.3 · D-830 — profile photos and videos.
    photos: "Fotoğraflar",
    mediaPhotoLabel: "Fotoğraf {n}/{total}",
    mediaVideoLabel: "Video {n}/{total}",
    mediaUnavailable: "Fotoğraflar yüklenemedi",
    mediaMore: "Daha fazla göster",
    // 9.35.4 · D-830 — removing one's own photo or video.
    mediaRemove: "Profilden kaldır",
    mediaRemovePhotoTitle: "Bu fotoğraf profilinden kaldırılsın mı?",
    mediaRemoveVideoTitle: "Bu video profilinden kaldırılsın mı?",
    mediaRemoveBody: "Dosya silinir ve geri getirilemez.",
    mediaRemoveFailed: "Kaldırılamadı. Tekrar dene.",
    webVisibility: 'Web sayfamı kimler görebilir',
    webVisibilityLink: 'Linki olanlar',
    webVisibilityInfo: 'Hesabı olmayanların gördüğü profilin: nosubject.co adresindeki sayfan. Herkes: sayfan arama motorlarında da çıkabilir. Linki olanlar: adresi bilen açar, arama motorları listelemez. Bu ikisinde hesabı olmayanlar profil bilgilerine, son görülmen dahil, erişebilir. Kimse: hesabı olmayan hiç kimse profilini göremez; sayfa “Bu profil bulunamadı” der. Uygulamadaki profilin değişmez. Arama sonuçlarından çıkmak birkaç gün sürebilir.',
    linkViewInfo: 'Mesaja yazdığın linkin nasıl gideceğini seçer. Kısa ve Büyük kart için telefonun sayfayı bir kez açar ve önizlemeyi mesajla gönderir; o site telefonunun IP adresini görür. Şifreli konuşmada önizleme şifrenin içindedir; şifresiz konuşmada nosubject linki ve önizlemeyi görür. Açık adres hiçbir sayfa açmaz. Web’den gönderilen linkler her zaman açık adres gider.',
    linkViewAsk: 'Yazarken seçenekleri göster',
    linkViewAskInfo: 'Açıksa link yazarken diğer iki görünüm de çıkar ve o mesaj için birini seçebilirsin. Kapalıysa link her zaman burada seçtiğin görünümle gider.',
    whoCanCallInfo: 'Seni kimin arayabileceğini seçer; her aramada uygulanır. Kişilerim, kendisine özel fiyat verdiğin kişilerdir. İstisnalar ile tek tek kişilere izin verebilir ya da kapatabilirsin.',
    whoCanMessageInfo: 'Sana yeni bir konuşmayı kimin başlatabileceğini seçer; başlamış konuşmalar etkilenmez. Kişilerim, kendisine özel fiyat verdiğin kişilerdir. İstisnalar ile tek tek kişilere izin verebilir ya da kapatabilirsin.',
    readReceiptsInfo: "Okundu bilgisi yalnızca iki kişi de açtığında görünür. Kapalı olsa da Düzenle seçeneğinin kaybolması mesajın okunduğunu belli edebilir.",
    showTypingInfo: 'Açıksa, yazdığın kişi sen yazarken bunu görür. Kapatırsan kimse görmez; sen başkalarının yazdığını görmeye devam edersin.',
    officialAccount: 'Resmî hesap',
    information: 'Profil bilgileri',
    logout: 'Çıkış yap',
    account: 'Hesap',
    accountData: 'Hesap ve veriler',
    name: 'Ad',
    surname: 'Soyad',
    username: 'Kullanıcı adı',
    usernamePlaceholder: 'kullaniciadi',
    usernameChecking: 'Kontrol ediliyor…',
    usernameAvailable: 'Kullanılabilir',
    usernameTaken: 'Bu kullanıcı adı alınmış',
    usernameInvalid: '3–20 karakter kullan. İlk karakter A–Z veya a–z olmalı; devamında A–Z, a–z, 0–9 ve _ kullanılabilir.',
    usernameAdd: 'Kullanıcı adı ekle',
    profession: 'Meslek',
    professionNone: 'Meslek eklenmemiş',
    professionAdd: 'Meslek ekle',
    employer: 'Çalıştığı şirket',
    employerPlaceholder: 'sirketkullaniciadi',
    employerInfo: 'Mevcut bir nosubject kullanıcı adı yaz. Bu atıf doğrulanmış işyeri anlamına gelmez.',
    employerNotFound: 'Bu kullanıcı adına sahip etkin bir hesap bulunamadı.',
    employerSelf: 'Kendi hesabını şirket olarak gösteremezsin.',
    bio: 'Kendini tanıt…',
    prices: 'Fiyatlar',
    settings: 'Ayarlar',
    priceMessage: 'Mesaj',
    priceVoice: 'Ses kaydı (dakika başına)',
    priceVoiceShort: 'Ses kaydı',
    priceCall: 'Şimdi ara (dakika başına)',
    priceCallShort: 'Şimdi ara',
    priceScheduledCall: 'Arama planla (dakika başına)',
    priceScheduledCallShort: 'Arama planla',
    priceVideoCall: 'Görüntülü arama',
    priceVideoCallShort: 'Görüntülü',
    priceTime: 'Buluşma (dakika başına)',
    priceTimeShort: 'Buluşma',
    currency: 'Para birimi',
    saving: 'Kaydediliyor…',
    wallet: 'Cüzdan',
    chatBackup: 'Sohbet yedeği',
    privacy: 'Gizlilik',
    readReceipts: 'Görüldü bilgisi',
    showTyping: 'Yazıyor bilgisi',
    keepArchived: 'Arşivi koru',
    keepArchivedInfo: 'Kapalıysa yeni mesaj konuşmayı arşivden çıkarır',
    whoCanMessage: 'Kimler bana yazabilir',
    whoCanCall: 'Kimler beni arayabilir',
    messagesFromContact: 'Bu kişiden mesajlar',
    callsFromContact: 'Bu kişiden aramalar',
    callExceptions: 'İstisnalar',
    callExceptionsEmpty: 'Henüz arama istisnası yok',
    messageExceptionsEmpty: 'Henüz mesaj istisnası yok',
    exceptionsLoadFailed: 'İstisnalar yüklenemedi',
    openProfileHint: 'Kişinin profilini açar',
    callExceptionBlocked: 'Engellendi',
    callsFromContactDefault: 'Varsayılan',
    callsFromContactAllow: 'Her zaman izin ver',
    callsFromContactBlock: 'Hiçbir zaman',
    everyone: 'Herkes',
    contacts: 'Kişilerim',
    nobody: 'Kimse',
    blockedUsers: 'Engellenenler',
    blockedEmpty: 'Kimseyi engellemedin',
    unblock: 'Engeli kaldır',
    appearance: 'Görünüm',
    light: 'Açık',
    dark: 'Koyu',
    system: 'Sistem',
    displayLanguage: 'Görüntüleme dili',
    education: 'Üniversite',
    educationAdd: 'Üniversite ekle',
    educationNone: 'Üniversite eklenmemiş',

    educationLevel: 'Eğitim düzeyi',
    searchLanguage: 'Dil ara…',
    photoChange: 'Değiştir',
    saveFailed: 'Kaydedilemedi.',
    photoFailed: 'Fotoğraf yüklenemedi.',
    photoChanged: "Fotoğraf başka bir işlemde değişti veya tekrar deneme süresi doldu. Fotoğrafı yeniden seç.",
    deleteAccount: 'Hesabı sil',
    deleteTitle: 'Hesabını sil',
    deleteMessage: 'Hesabın 30 gün sonra kalıcı olarak silinecek. Bu süre içinde tekrar girip iptal edebilirsin.',
    deleteMoneyWarning: 'Cüzdanında ve emanette {amount} var. Silmeden önce çekmen önerilir.',
    deleteConfirm: 'Sil',
    deleteFailed: 'Hesap silinemedi.',
    deletionScheduled: 'Hesabın {date} tarihinde silinecek.',
    deletionCancel: 'Hesap silme işlemini iptal et',
    exportData: 'Verilerimi indir',
    exportFailed: 'Veriler alınamadı.',
  },
  // Alt bar (dock) — ekran okuyucu etiketleri ve rozet sayıları (9.26.7.2.1)
  dock: {
    calls: 'Aramalar',
    discover: 'Keşfet',
    inbox: 'Mesajlar',
    calendar: 'Takvim',
    profile: 'Profil',
    unreadMessages: '{count} okunmamış',
    pendingRequests: '{count} bekleyen istek',
  },
  // 9.18.10.4 · D-830 — importing one's own Instagram download.
  instagramImport: {
    title: "Instagram’dan getir",
    addEntry: "Instagram’dan getir",
    guideIntro: "Kendi Instagram verini indirip buradan seçerek fotoğraf ve videolarını profiline ekleyebilirsin.",
    guideStep1: "Instagram’da Hesaplar Merkezi → Bilgilerin ve izinlerin → Bilgilerini indir’e git.",
    guideStep2: "“Bilgilerinin bir kısmı”nda yalnız İçerik’i seç; biçim JSON, medya kalitesi Yüksek olsun.",
    guideStep3: "Meta dosyayı hazırlayınca indir ve buradan seç.",
    guideOwnOnly: "Yalnız senin paylaştığın fotoğraf ve videolar listelenir; mesajlardaki medya alınmaz.",
    guideOnDevice: "Dosya cihazında açılır ve sunucuya gönderilmez; yalnız seçtiklerin yüklenir.",
    choose: "ZIP dosyasını seç",
    reading: "Arşiv okunuyor",
    notZip: "Bu dosya bir ZIP arşivi değil.",
    untrusted: "Bu arşiv güvenli görünmüyor, açılmadı.",
    tooBig: "Bu arşiv çok büyük.",
    unreadable: "Bu arşiv okunamadı.",
    chooseAnother: "Başka dosya seç",
    noMedia: "Bu arşivde eklenebilecek fotoğraf ya da video bulunamadı.",
    found: "{count} fotoğraf ve video bulundu",
    slotsLeft: "Profilinde {count} yer kaldı",
    selectAll: "Tümünü seç",
    selectNone: "Seçimi kaldır",
    alreadyOnProfile: "Profilde",
    tooLarge: "Çok büyük",
    add: "{count} öğeyi ekle",
    adding: "{n}/{total} ekleniyor",
    stop: "Durdur",
    stopping: "Bu öğeden sonra duruyor",
    doneAdded: "{count} öğe eklendi",
    doneDuplicate: "{count} öğe zaten profildeydi",
    doneSkipped: "{count} öğe atlandı",
    doneFailed: "{count} öğe eklenemedi",
    retryFailed: "Eklenemeyenleri tekrar dene",
    profileFull: "Profilin doldu; daha fazla öğe eklenemedi.",
    guideParts: "Meta indirmeyi birkaç ZIP parçasına böldüyse hepsini birlikte seç.",
    catAll: "Tümü",
    catPosts: "Gönderiler",
    catReels: "Reels",
    catStories: "Hikâyeler",
    catIgtv: "IGTV",
    catArchived: "Arşiv",
    catProfile: "Profil fotoğrafları",
    catOther: "Diğer",
    archiveSection: "Instagram indirmesi",
    archiveHint: "Kendi indirdiğin verideki fotoğraf ve videoları profiline ekler.",
  },
};
